export default __webpack_public_path__ + "static/media/Ballroll_00114.b8717510.png";